import { render, staticRenderFns } from "./Claim.vue?vue&type=template&id=534659eb&scoped=true&"
import script from "./Claim.vue?vue&type=script&lang=ts&"
export * from "./Claim.vue?vue&type=script&lang=ts&"
import style0 from "./Claim.vue?vue&type=style&index=0&id=534659eb&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "534659eb",
  null
  
)

export default component.exports